var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1104.076 801"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 10",
    d: "M440.576 800.5h-154.6c-75.949 0-113.925-65.874-113.925-65.874l-154.6-268.235c-37.974-65.874 0-131.747 0-131.747L172.06 66.408C210.03.5 285.976.5 285.976.5h817.6v800z",
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10
  })));
}
export default SvgArrowMask;